import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AgEntitiesInfoModalComponent } from '../ag-entities-info-modal/ag-entities-info-modal.component';

@Component({
  standalone: false,
  selector: 'app-ag-entities-success',
  templateUrl: './ag-entities-success.component.html',
  styleUrls: ['./ag-entities-success.component.scss'],
})
export class AgEntitiesSuccessComponent {
  constructor(private _dialog: MatDialog) {}

  modify(): void {
    this._dialog.open(AgEntitiesInfoModalComponent);
  }
}
